module.exports = __webpack_public_path__ + "static/media/square-purple-1.e8f90cff.png";